(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mk-product-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mk-purchase-summary')) {
    customElements.define('mk-purchase-summary', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;
        this.dialog = this.querySelector('dialog');
        this.update = this.update.bind(this);
        this.open = () => this.dialog.showModal();
        this.close = () => this.dialog.close();
        this.dismiss = event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.close();
        };
        this.form.addEventListener('input', this.update);
        this.form.addEventListener('change', this.update);
        this.form.addEventListener('quantity-selector:update', this.update);
        this.querySelector('.mk-purchase__learn').addEventListener('click', this.open);
        this.querySelector('.mk-purchase__close').addEventListener('click', this.close);
        this.dialog.addEventListener('click', this.dismiss);
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.form, {subtree: true, childList: true, attributes: true, attributeFilter: ['data-unit-cents']});
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.form?.removeEventListener('input', this.update);
        this.form?.removeEventListener('change', this.update);
        this.form?.removeEventListener('quantity-selector:update', this.update);
        this.querySelector('.mk-purchase__learn')?.removeEventListener('click', this.open);
        this.querySelector('.mk-purchase__close')?.removeEventListener('click', this.close);
        this.dialog?.removeEventListener('click', this.dismiss);
      }

      update() {
        const price = this.form.querySelector('[data-mk-purchase-total]');
        const unit = Number(price?.dataset.unitCents || 0);
        const quantity = Math.max(1, Number(this.form.elements.quantity?.value) || 1);
        const total = Math.round(unit * quantity);
        const formatter = new Intl.NumberFormat(this.dataset.locale || 'fr', {style: 'currency', currency: this.dataset.currency || 'EUR'});
        const label = `(${formatter.format(total / 100)})`;
        if (price && price.textContent !== label) price.textContent = label;
        this.querySelector('.mk-purchase__installments').hidden = this.dataset.installmentsEnabled !== 'true' || !price || total < 3500 || total > 1000000;
        const installment = Math.floor(total / 3);
        this.querySelectorAll('[data-mk-installment]').forEach((element, index) => {
          const amount = formatter.format((installment + (index < total % 3 ? 1 : 0)) / 100);
          if (element.textContent !== amount) element.textContent = amount;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
